import { ArrowLeft, Mail } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

export function CareersFoundingEngineer() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <div className="pt-28 px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <button
            onClick={() => navigate("/careers")}
            className="flex items-center gap-2 text-blue-400 hover:text-blue-300 transition font-medium mb-8"
          >
            <ArrowLeft size={20} />
            Back to careers
          </button>
        </div>
      </div>

      {/* Job Header */}
      <section className="px-6 lg:px-8 pb-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl font-bold mb-4">
            Founding Engineer/Technical Lead
          </h1>
          <p className="text-xl mb-8">📍 Remote, US</p>
        </div>
      </section>

      {/* Content Sections */}
      <section className="px-6 lg:px-8 py-24 border-t border-gray-800">
        <div className="max-w-4xl mx-auto space-y-16">
          {/* About the Role */}
          <div>
            <h2 className="text-3xl font-bold mb-6">About the company</h2>
            <p>
              ExpenseHut is a digital platform designed to enhance businesses
              and individuals by boosting financial and everyday productivity.
              We are an Austin-based startup, and we offer innovative and
              advanced solutions that address real-world challenges across
              industries like retail, restaurants, staffing, and content.
            </p>
            <p>
              Business, by ExpenseHut is an all-in-one enterprise business
              software suite that includes POS with omnichannel payments,
              embedded payroll, bookkeeping software, and rewards. Our platform
              features tools tailored to businesses of all sizes, with the aim
              of helping users gain financial clarity and achieve lasting
              success.
            </p>
            <p>
              Join us in making smarter decisions today for a more prosperous
              tomorrow!
            </p>
          </div>

          {/* Responsibilities */}
          <div>
            <h2 className="text-3xl font-bold   mb-6">Responsibilities</h2>
            <ul className="space-y-4">
              <li className="my-4">
                <strong>Technology Strategy & Leadership:</strong>
                <div>
                  Develop and execute the company's technology roadmap in
                  alignment with business goals.
                </div>
              </li>

              <li className="my-4">
                <strong>Product Development & Innovation:</strong>
                <div>
                  Lead the engineering team in designing, developing, and
                  deploying scalable and secure technology solutions.
                </div>
              </li>
              <li className="my-4">
                <strong>Team Management & Growth:</strong>
                <div>
                  Build and manage a high-performing technology team, fostering
                  innovation and continuous improvement.
                </div>
              </li>
              <li className="my-4">
                <strong>Collaboration with Business Units:</strong>
                <div>
                  Work closely with other departments to align technological
                  advancements with operational and customer needs.
                </div>
              </li>
              <li className="my-4">
                <strong>Compliance & Risk Management:</strong>
                <div>
                  Ensure adherence to regulatory requirements and implement best
                  practices in data security and risk management.
                </div>
              </li>
              <li className="my-4">
                <strong>Vendor & Partnership Management:</strong>
                <div>
                  Oversee relationships with external technology vendors,
                  partners, and service providers.
                </div>
              </li>
              <li className="my-4">
                <strong>Technology Budgeting & Planning: </strong>
                <div>
                  Develop and manage the technology budget, ensuring optimal
                  resource allocation and cost control.
                </div>
              </li>
            </ul>
          </div>

          {/* Requirements */}
          <div>
            <h2 className="text-3xl font-bold   mb-6">Requirements</h2>
            <ul className="space-y-4">
              <li>
                At least 15+ years of progressive experience in software
                development.
              </li>
              <li>5+ years of experience leading engineering teams.</li>
              <li>
                Experience in full-stack engineering in at least one frontend,
                one backend, and cloud infrastructure.
              </li>
              <li>
                Experience in one or more programming languages - Javascript,
                Java and/or Python.
              </li>
              <li>
                Familiarity with cloud technologies and experience in building
                scalable and secure cloud-based solutions.
              </li>
              <li>
                Experience with at least two cloud providers - AWS, GCP, or
                Azure.{" "}
              </li>
              <li>
                Should have experience contributing to engineering directly
                mapping with product growth.
              </li>
              <li>
                Bachelors degree in Computer Science or related. Masters degree
                preferred.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-3xl font-bold   mb-6">
              Preferred Qualifications
            </h2>
            <ul className="space-y-4">
              <li>Polyglot and experience in full stack applications.</li>
              <li>7+ years of experience leading engineering teams.</li>
              <li>
                Proven experience in scaling cloud services with high volume of
                traffic.
              </li>
              <li>Azure cloud and Azure devops.</li>
              <li>Masters degree or equivalent.</li>
            </ul>
          </div>

          {/* How to Apply */}
          <div className="border border-gray-700 rounded-xl p-8">
            <h2 className="text-2xl font-bold mb-4">How to Apply</h2>

            <p>
              Please email <strong>jobs@expensehut.com</strong> with your resume
              attached. Please make sure to answer the following questions to
              help us understand your experience better.
            </p>
          </div>
        </div>
        <div className="p-6 text-gray-600 mt-10">
          ExpenseHut is an Equal Employment Opportunity and, in the U.S., an
          Affirmative Action employer. All qualified applicants will receive
          consideration for employment without regard to unlawful consideration
          of race, color, religion, creed, national or ethnic origin, ancestry,
          place of birth, citizenship, sex, pregnancy / childbirth or related
          medical conditions, sexual orientation, gender identity or expression,
          marital or domestic partnership status, age, veteran or military
          status, physical or mental disability, medical condition, genetic
          information, political / organizational affiliation, status as a
          victim or family member of a victim of crime or abuse, or any other
          status protected by applicable law.
        </div>
      </section>
    </div>
  );
}
